import { FaPencilAlt } from 'react-icons/fa'

import { Button } from '../../../../../components/Button'
import { usePermission } from '../../../../../hooks/usePermission'
import { PromotersCompany } from '../../../../../services/promotersCompaniesServices'
import { formatCNPJ } from '../../../../../utils/formatCNPJ'

interface TablePromotersCompanyRowProps {
  promotersCompany: PromotersCompany
  onEdit: (promotersCompany: PromotersCompany) => void
}

export function PromotersCompanyTableRow({ promotersCompany, onEdit }: TablePromotersCompanyRowProps) {
  const { upsertPromotersCompany, isObserver } = usePermission()

  return (
    <tr
      className="border-t border-slate-500 hover:bg-white_transparency hover:bg-opacity-15"
    >
      <td
        scope="row"
        className="font-medium whitespace-nowrap sticky left-0 border-r border-slate-500 pl-2"
      >
        <span>{promotersCompany.name}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap text-center sticky left-0 border-r border-slate-500 p-2"
      >
        <span>{formatCNPJ(promotersCompany.document)}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky p-2 text-center"
      >
        <div className="flex flex-row justify-center">
          <Button
            size="icon"
            title="Editar usuário"
            disabled={!upsertPromotersCompany || isObserver}
            onClick={() => onEdit(promotersCompany)}
            className="disabled:bg-slate-400 hover:disabled:bg-slate-400 disabled:cursor-not-allowed"
          >
            <FaPencilAlt />
          </Button>
        </div>
      </td>
    </tr>
  )
}
